// Stub for drizzle-orm/pg-core in client builds
// These functions return chainable objects with methods like primaryKey(), notNull(), default(), etc.

function createColumnStub() {
  const stub: any = {
    primaryKey: () => stub,
    notNull: () => stub,
    default: () => stub,
    defaultNow: () => stub,
    unique: () => stub,
    references: () => stub,
    $type: () => stub,
  };
  return stub;
}

export const pgTable = ((name: string, schema: any) => {
  if (typeof window !== 'undefined') {
    console.warn('drizzle-orm pgTable() called in client - this should not happen');
  }
  return schema;
}) as any;

export const text = (() => createColumnStub()) as any;
export const varchar = (() => createColumnStub()) as any;
export const integer = (() => createColumnStub()) as any;
export const timestamp = (() => createColumnStub()) as any;
export const boolean = (() => createColumnStub()) as any;
export const json = (() => createColumnStub()) as any;
export const unique = (() => createColumnStub()) as any;
export const doublePrecision = (() => createColumnStub()) as any;
export const serial = (() => createColumnStub()) as any;

